/**
 * UnauthorizedPage — shown when a signed-in user lacks the role for a route.
 */

import { type ReactNode } from 'react'
import { Link }            from 'react-router'
import { useTranslation }  from 'react-i18next'
import { useSignOut }      from '@/hooks/useAuth'
import { PATHS }           from '@/router/paths'

export function UnauthorizedPage(): ReactNode {
  const { t }   = useTranslation()
  const signOut = useSignOut()
  return (
    <main
      style={{
        minHeight:      '100vh',
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        background:     'var(--brand-neutral-50)',
        fontFamily:     'var(--brand-font-family)',
        padding:        '1rem',
      }}
    >
      <div
        role="alert"
        style={{
          maxWidth:     '28rem',
          background:   'var(--brand-white)',
          border:       '1px solid var(--brand-neutral-300)',
          borderRadius: 'var(--brand-radius-lg)',
          padding:      '1.5rem',
          textAlign:    'center',
        }}
      >
        <h1 style={{ margin: 0, fontSize: '1.25rem' }}>{t('auth.accessDenied')}</h1>
        <p style={{ marginTop: '0.5rem', color: 'var(--brand-neutral-500)' }}>
          {t('auth.accessDeniedDetail')}
        </p>
        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center', marginTop: '1rem' }}>
          <Link
            to={PATHS.dashboard}
            style={{
              padding:        '0.5rem 1rem',
              background:     'var(--brand-primary)',
              color:          'var(--brand-white)',
              borderRadius:   'var(--brand-radius-md)',
              textDecoration: 'none',
              fontSize:       '0.9rem',
            }}
          >
            {t('auth.goToDashboard')}
          </Link>
          <button
            type="button"
            onClick={() => { void signOut() }}
            style={{
              padding:      '0.5rem 1rem',
              background:   'transparent',
              color:        'var(--brand-neutral-700)',
              border:       '1px solid var(--brand-neutral-300)',
              borderRadius: 'var(--brand-radius-md)',
              fontSize:     '0.9rem',
              cursor:       'pointer',
            }}
          >
            {t('auth.signOut')}
          </button>
        </div>
      </div>
    </main>
  )
}
